import React from "react";
import type { ErrorFallbackProps } from "./types";
import { useTranslation } from "react-i18next";
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetError }) => {
	const { t } = useTranslation();

	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-50">
			<div className="text-center p-8 bg-white rounded-lg shadow-lg max-w-lg">
				<div className="text-red-500 mb-4">
					<WarningAmberOutlinedIcon sx={{ fontSize: 200 }} />
				</div>
				<h2 className="text-2xl font-bold text-foreground mb-4">{t("psdaCommon.messages.error.somethingWentWrong")}</h2>
				<p className="text-gray-600 mb-6">{error?.message || t("psdaCommon.messages.error.api.genericError")}</p>
				<button
					onClick={resetError}
					className="bg-blue-600 text-white px-6 py-2 rounded-[5px] hover:bg-blue-700 transition-colors">
					{t("psdaCommon.common.buttons.refresh")}
				</button>
			</div>
		</div>
	);
};
